/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Box,
  Typography,
  Chip,
  FormHelperText,
  Paper,
  LinearProgress,
  Stepper,
  Step,
  StepLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  ListItemText,
  CircularProgress,
} from "@material-ui/core"
import {
  Fingerprint,
  CloudDownload,
  CloudUpload,
  GetApp,
  CheckCircle,
  Error as ErrorIcon,
  Publish,
  DevicesOther,
  AddToHomeScreen,
} from "@material-ui/icons"
import { DropzoneArea } from "material-ui-dropzone"
import {
  getFloorChipSmallStyle,
  getImportRowStyle,
  getImportChipStyle,
  importSummaryPaperStyles,
} from "./NewAndEditRostro.styles"

const ImportMasivoDialog = ({
  open,
  onClose,
  importLoading,
  importStep,
  setImportStep,
  importSteps,
  // paso 0
  handleDownloadTemplate,
  // paso 1
  zipFile,
  zipProcessing,
  zipImages,
  handleZipFileChange,
  handleProcessImportFile,
  // paso 2
  importData,
  importErrors,
  currentPage,
  setCurrentPage,
  pageSize,
  LazyImage,
  handleDownloadErrors,
  handleDevicesSelect,
  // paso 3
  biometricDevices,
  selectedBiometricDevices,
  handleBiometricDeviceSelectionChange,
  handleMassImport,
  // paso 4
  importResults,
  getDeviceNameById,
  // misc
  handleContinueWithDevices,
  importFile,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    disableBackdropClick={importLoading}
  >
    <DialogTitle>
      <Box display="flex" alignItems="center">
        <Publish style={{ marginRight: 8 }} />
        Importación Masiva de Rostros
      </Box>
    </DialogTitle>

    <DialogContent>
      <Box mb={3}>
        <Stepper activeStep={importStep} alternativeLabel>
          {importSteps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* ── Paso 0: Descargar Plantilla ── */}
      {importStep === 0 && (
        <Box textAlign="center" py={4}>
          <CloudDownload
            style={{ fontSize: 64, color: "#1976d2", marginBottom: 16 }}
          />
          <Typography variant="h6" gutterBottom>
            Paso 1: Descargar Plantilla
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            Descargue la plantilla Excel con todas las columnas necesarias,
            ejemplos y validaciones.
          </Typography>
          <Box display="flex" gap={2} justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetApp style={{ color: "white" }} />}
              onClick={handleDownloadTemplate}
              size="large"
            >
              Descargar Plantilla
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setImportStep(1)}
              size="large"
            >
              Ya tengo la plantilla
            </Button>
          </Box>
        </Box>
      )}

      {/* ── Paso 1: Subir ZIP ── */}
      {importStep === 1 && (
        <Box py={4}>
          <Box textAlign="center" mb={3}>
            <CloudUpload
              style={{ fontSize: 64, color: "#1976d2", marginBottom: 16 }}
            />
            <Typography variant="h6" gutterBottom>
              Paso 2: Cargar Archivo ZIP
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Arrastre y suelte el archivo ZIP o haga clic para seleccionar
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center">
            <Box width="100%" maxWidth={500}>
              <DropzoneArea
                acceptedFiles={[".zip"]}
                dropzoneText="Arrastre el archivo ZIP aquí o haga clic para seleccionar"
                onChange={files => {
                  if (files.length > 0)
                    handleZipFileChange({ target: { files } })
                }}
                filesLimit={1}
                maxFileSize={100000000}
                showPreviews={false}
                showPreviewsInDropzone={false}
                useChipsForPreview
                Icon={CloudUpload}
                showAlerts={false}
              />
              {zipProcessing && (
                <Box mt={2}>
                  <LinearProgress />
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    align="center"
                    display="block"
                    mt={1}
                  >
                    Extrayendo imágenes del ZIP...
                  </Typography>
                </Box>
              )}
              {zipFile && !zipProcessing && (
                <Box mt={2} textAlign="center">
                  <Chip
                    icon={<GetApp />}
                    label={`${zipFile.name} (${zipImages.size} imágenes)`}
                    color="primary"
                    variant="outlined"
                    style={{ marginBottom: 16 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleProcessImportFile}
                    disabled={importLoading}
                    fullWidth
                    size="large"
                    startIcon={<CloudUpload style={{ color: "white" }} />}
                  >
                    {importLoading ? "Procesando..." : "Procesar Archivo ZIP"}
                  </Button>
                </Box>
              )}
              {importLoading && (
                <Box mt={2}>
                  <LinearProgress />
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    align="center"
                    display="block"
                    mt={1}
                  >
                    Procesando datos del archivo...
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {/* ── Paso 2: Validar ── */}
      {importStep === 2 && importData && (
        <Box py={2}>
          <Typography variant="h6" gutterBottom>
            Paso 3: Validación de datos
          </Typography>

          <Grid container spacing={2} style={{ marginBottom: 16 }}>
            {[
              {
                label: "Total Filas",
                value: importData.totalRows,
                color: "primary",
                bg: "white",
              },
              {
                label: "Válidas",
                value: importData.validRows,
                color: "#4caf50",
                bg: "#e8f5e8",
              },
              {
                label: "Con Errores",
                value: importData.invalidRows,
                color: "#ff9800",
                bg: "#fff3e0",
              },
            ].map(({ label, value, color, bg }) => (
              <Grid key={label} item xs={12} sm={3}>
                <Paper
                  style={{
                    padding: 16,
                    textAlign: "center",
                    backgroundColor: bg,
                  }}
                >
                  <Typography variant="h4" style={{ color }}>
                    {value}
                  </Typography>
                  <Typography variant="caption">{label}</Typography>
                </Paper>
              </Grid>
            ))}
            <Grid item xs={12} sm={3}>
              <Paper style={{ padding: 16, textAlign: "center" }}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<GetApp />}
                  onClick={handleDownloadErrors}
                  disabled={!importErrors || importErrors.length === 0}
                >
                  Descargar Errores
                </Button>
              </Paper>
            </Grid>
          </Grid>

          {importData.data?.length > 0 && (
            <Box mb={3}>
              <Typography variant="h6" gutterBottom>
                Previsualización ({importData.data.length} rostros)
              </Typography>
              {importData.data.length > pageSize && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="body2">
                    Mostrando {currentPage * pageSize + 1}–
                    {Math.min(
                      (currentPage + 1) * pageSize,
                      importData.data.length
                    )}{" "}
                    de {importData.data.length}
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Button
                      size="small"
                      onClick={() =>
                        setCurrentPage(Math.max(0, currentPage - 1))
                      }
                      disabled={currentPage === 0}
                    >
                      Anterior
                    </Button>
                    <Typography variant="body2" style={{ margin: "0 16px" }}>
                      Página {currentPage + 1} de{" "}
                      {Math.ceil(importData.data.length / pageSize)}
                    </Typography>
                    <Button
                      size="small"
                      onClick={() =>
                        setCurrentPage(
                          Math.min(
                            Math.ceil(importData.data.length / pageSize) - 1,
                            currentPage + 1
                          )
                        )
                      }
                      disabled={
                        currentPage >=
                        Math.ceil(importData.data.length / pageSize) - 1
                      }
                    >
                      Siguiente
                    </Button>
                  </Box>
                </Box>
              )}
              <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                      {[
                        "Foto",
                        "Nombre",
                        "Identificación",
                        "Unidad",
                        "Tipo",
                        "Estado",
                        "Pisos",
                        "Imagen",
                        "PIN",
                        "TAGs / QRs",
                        "Observaciones",
                      ].map(h => (
                        <TableCell key={h}>
                          <strong>{h}</strong>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importData.data
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((rostro, idx) => (
                        <TableRow key={currentPage * pageSize + idx}>
                          <TableCell>
                            <LazyImage rostro={rostro} zipImages={zipImages} />
                          </TableCell>
                          <TableCell>{rostro.nombre}</TableCell>
                          <TableCell>{rostro.identificacion}</TableCell>
                          <TableCell>{rostro.destino || "-"}</TableCell>
                          <TableCell>
                            <Chip
                              label={rostro.tipo}
                              size="small"
                              style={{
                                backgroundColor: "#e3f2fd",
                                color: "#1976d2",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={rostro.estado}
                              size="small"
                              style={{
                                backgroundColor:
                                  rostro.estado === "activo"
                                    ? "#e8f5e8"
                                    : "#fff3e0",
                                color:
                                  rostro.estado === "activo"
                                    ? "#4caf50"
                                    : "#ff9800",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {rostro.pisos?.length > 0 ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {rostro.pisos.map((p, i) => (
                                  <Chip
                                    key={i}
                                    label={p < 0 ? `S${Math.abs(p)}` : `P${p}`}
                                    size="small"
                                    style={getFloorChipSmallStyle(p)}
                                  />
                                ))}
                              </Box>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>{rostro.imagen || "-"}</TableCell>
                          <TableCell>
                            {rostro.pin ? (
                              <Chip
                                size="small"
                                label={`PIN: ${"•".repeat(rostro.pin.length)}`}
                                style={{
                                  backgroundColor: "#e8f5e9",
                                  color: "#2e7d32",
                                  fontSize: "0.65rem",
                                  height: 18,
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            <Box
                              display="flex"
                              flexWrap="wrap"
                              style={{ gap: 2 }}
                            >
                              {(rostro.tarjeta || [])
                                .slice(0, 3)
                                .map((t, ti) => (
                                  <Chip
                                    key={ti}
                                    size="small"
                                    label={`${t.tipo.toUpperCase()}: ${t.codigo.substring(0, 6)}...`}
                                    style={{
                                      backgroundColor:
                                        t.tipo === "tag"
                                          ? "#e3f2fd"
                                          : "#f3e5f5",
                                      color:
                                        t.tipo === "tag"
                                          ? "#1976d2"
                                          : "#7b1fa2",
                                      fontSize: "0.6rem",
                                      height: 18,
                                    }}
                                  />
                                ))}
                              {(rostro.tarjeta || []).length > 3 && (
                                <Chip
                                  size="small"
                                  label={`+${rostro.tarjeta.length - 3}`}
                                  style={{ fontSize: "0.6rem", height: 18 }}
                                />
                              )}
                              {!(rostro.tarjeta || []).length && "-"}
                            </Box>
                          </TableCell>
                          <TableCell>{rostro.observaciones || "-"}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {importErrors?.length > 0 && (
            <Box mb={3}>
              <Typography variant="h6" gutterBottom color="error">
                Errores ({importErrors.length})
              </Typography>
              <TableContainer component={Paper} style={{ maxHeight: 300 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {["Fila", "Errores", "Nombre", "Identificación"].map(
                        h => (
                          <TableCell key={h}>{h}</TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importErrors.slice(0, 10).map((err, i) => (
                      <TableRow key={i}>
                        <TableCell>{err.row}</TableCell>
                        <TableCell>
                          <Typography variant="body2" color="error">
                            {err.errors.join(", ")}
                          </Typography>
                        </TableCell>
                        <TableCell>{err.data?.nombre || "-"}</TableCell>
                        <TableCell>{err.data?.identificacion || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {importData.validRows > 0 && (
            <Box textAlign="center">
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleDevicesSelect}
                disabled={importLoading}
                startIcon={
                  importLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <AddToHomeScreen style={{ color: "white" }} />
                  )
                }
              >
                {importLoading
                  ? "Revisando dispositivos..."
                  : "Seleccionar Dispositivos"}
              </Button>
            </Box>
          )}
        </Box>
      )}

      {/* ── Paso 3: Dispositivos ── */}
      {importStep === 3 && (
        <Box py={4}>
          <Box textAlign="center" mb={3}>
            <DevicesOther
              style={{ fontSize: 64, color: "#1976d2", marginBottom: 16 }}
            />
            <Typography variant="h6" gutterBottom>
              Paso 4: Seleccionar Dispositivos Biométricos
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Seleccione los dispositivos donde desea importar los{" "}
              {importData?.validRows || 0} rostros válidos.
            </Typography>
          </Box>

          {importData && (
            <Box mb={3}>
              <Paper style={{ padding: 16, backgroundColor: "#f5f5f5" }}>
                <Typography variant="subtitle2" gutterBottom>
                  Resumen del archivo:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body2">
                      <strong>{importData.totalRows}</strong> filas totales
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2" style={{ color: "#4caf50" }}>
                      <strong>{importData.validRows}</strong> válidas
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2" style={{ color: "#ff9800" }}>
                      <strong>{importData.invalidRows}</strong> con errores
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}

          <FormControl
            fullWidth
            required
            error={selectedBiometricDevices.length === 0}
          >
            <InputLabel>Dispositivos Biométricos</InputLabel>
            <Select
              multiple
              value={selectedBiometricDevices}
              onChange={handleBiometricDeviceSelectionChange}
              renderValue={selected => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map(val => {
                    const dev = biometricDevices.find(d => d.id === val)
                    return (
                      <Chip
                        key={val}
                        label={dev ? `${dev.nombre} (${dev.ubicacion})` : val}
                        size="small"
                        icon={<Fingerprint style={{ fontSize: 16 }} />}
                        style={{
                          backgroundColor:
                            dev?.estado === "active" ? "#e8f5e8" : "#fff3e0",
                          color:
                            dev?.estado === "active" ? "#2e7d32" : "#f57c00",
                        }}
                      />
                    )
                  })}
                </Box>
              )}
            >
              {biometricDevices.length === 0 ? (
                <MenuItem disabled>
                  <Typography variant="body2">
                    No hay dispositivos disponibles
                  </Typography>
                </MenuItem>
              ) : (
                biometricDevices.map(dev => (
                  <MenuItem
                    key={dev.id}
                    value={dev.id}
                    disabled={dev.estado !== "active"}
                  >
                    <Checkbox
                      checked={selectedBiometricDevices.indexOf(dev.id) > -1}
                      disabled={dev.estado !== "active"}
                    />
                    <ListItemText>
                      <Box display="flex" alignItems="center">
                        <Fingerprint
                          style={{
                            marginRight: 8,
                            fontSize: 18,
                            color:
                              dev.estado === "active" ? "#1976d2" : "#bdbdbd",
                          }}
                        />
                        <Box flex={1}>
                          <Typography
                            variant="body2"
                            style={{
                              color:
                                dev.estado === "active" ? "inherit" : "#bdbdbd",
                            }}
                          >
                            {dev.nombre}
                          </Typography>
                          <Typography
                            variant="caption"
                            style={{
                              color:
                                dev.estado === "active" ? "#64748b" : "#bdbdbd",
                            }}
                          >
                            {dev.ubicacion}
                          </Typography>
                        </Box>
                        <Chip
                          size="small"
                          label={
                            dev.estado === "active"
                              ? "ACTIVO"
                              : dev.estado === "unknown"
                                ? "DESCONOCIDO"
                                : "INACTIVO"
                          }
                          style={{
                            backgroundColor:
                              dev.estado === "active" ? "#e8f5e8" : "#f5f5f5",
                            color:
                              dev.estado === "active" ? "#2e7d32" : "#757575",
                            fontSize: "0.7rem",
                            height: 20,
                            fontWeight: "bold",
                          }}
                        />
                      </Box>
                    </ListItemText>
                  </MenuItem>
                ))
              )}
            </Select>
            <FormHelperText>
              {selectedBiometricDevices.length > 0
                ? `${selectedBiometricDevices.length} dispositivo(s) para ${importData?.validRows || 0} rostros`
                : "Seleccione al menos un dispositivo biométrico"}
            </FormHelperText>
          </FormControl>

          <Box textAlign="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleMassImport}
              disabled={selectedBiometricDevices.length === 0 || importLoading}
            >
              {importLoading
                ? "Importando..."
                : `Importar ${importData?.validRows} Rostros en ${selectedBiometricDevices.length} Dispositivo(s)`}
            </Button>
          </Box>
        </Box>
      )}

      {/* ── Paso 4: Resultados ── */}
      {importStep === 4 && (
        <Box py={2}>
          <Box textAlign="center" mb={3}>
            <CheckCircle
              style={{ fontSize: 48, color: "#4caf50", marginBottom: 8 }}
            />
            <Typography variant="h6" gutterBottom color="primary">
              Importación Completada
            </Typography>
            {importResults.summary && (
              <Grid
                container
                spacing={2}
                style={{ marginTop: 16, marginBottom: 24 }}
              >
                <Grid item xs={12} sm={3}>
                  <Paper style={importSummaryPaperStyles.total}>
                    <Typography variant="h5" color="primary">
                      {importResults.summary.total_rostros_enviados || 0}
                    </Typography>
                    <Typography variant="caption">Total Enviados</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Paper style={importSummaryPaperStyles.exitoso}>
                    <Typography variant="h5" style={{ color: "#4caf50" }}>
                      {importResults.successful.length || 0}
                    </Typography>
                    <Typography variant="caption">Exitosos</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Paper style={importSummaryPaperStyles.fallido}>
                    <Typography variant="h5" style={{ color: "#f44336" }}>
                      {importResults.failed.length || 0}
                    </Typography>
                    <Typography variant="caption">Fallidos</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Paper style={importSummaryPaperStyles.tasa}>
                    <Typography variant="h5" style={{ color: "#9c27b0" }}>
                      {Math.round(
                        ((importResults.successful.length || 0) /
                          (importResults.summary.total_rostros_enviados || 1)) *
                          100
                      )}
                      %
                    </Typography>
                    <Typography variant="caption">Tasa de Éxito</Typography>
                  </Paper>
                </Grid>
              </Grid>
            )}
          </Box>

          <Typography variant="h6" gutterBottom>
            Resultados Detallados
          </Typography>
          <TableContainer component={Paper} style={{ maxHeight: 500 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  {[
                    "#",
                    "Estado",
                    "Identificación",
                    "Nombre",
                    "Dispositivos",
                    "Detalles",
                  ].map(h => (
                    <TableCell key={h}>
                      <strong>{h}</strong>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {[...importResults.successful, ...importResults.failed]
                  .sort((a, b) => a.index - b.index)
                  .map(r => (
                    <TableRow key={r.id} style={getImportRowStyle(r.estado)}>
                      <TableCell>{r.index + 1}</TableCell>
                      <TableCell>
                        <Chip
                          icon={
                            r.estado === "exitoso" ? (
                              <CheckCircle style={{ fontSize: 16 }} />
                            ) : (
                              <ErrorIcon style={{ fontSize: 16 }} />
                            )
                          }
                          label={r.estado === "exitoso" ? "EXITOSO" : "FALLIDO"}
                          size="small"
                          style={getImportChipStyle(r.estado)}
                        />
                      </TableCell>
                      <TableCell>
                        <strong>{r.identificacion}</strong>
                      </TableCell>
                      <TableCell>{r.nombre}</TableCell>
                      <TableCell>
                        {r.estado === "exitoso" ? (
                          <Box>
                            <Typography
                              variant="body2"
                              color="primary"
                              style={{ fontWeight: "bold" }}
                            >
                              ✅ {r.dispositivos_nombres?.join(", ") || "N/A"}
                            </Typography>
                            {r.dispositivos_omitidos?.length > 0 && (
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{ fontStyle: "italic" }}
                              >
                                Omitidos: {r.dispositivos_omitidos.join(", ")}
                              </Typography>
                            )}
                          </Box>
                        ) : (
                          <Box>
                            <Typography
                              variant="body2"
                              color="error"
                              style={{ fontWeight: "bold" }}
                            >
                              ❌{" "}
                              {r.dispositivos_nombres?.join(", ") ||
                                "Todos los dispositivos"}
                            </Typography>
                            {r.dispositivos_con_problema?.length > 0 && (
                              <Typography
                                variant="caption"
                                color="error"
                                style={{ fontStyle: "italic" }}
                              >
                                Duplicado en:{" "}
                                {r.dispositivos_con_problema.join(", ")}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body2"
                          color={r.estado === "exitoso" ? "primary" : "error"}
                          style={{
                            fontWeight:
                              r.estado === "exitoso" ? "normal" : "bold",
                          }}
                        >
                          {r.razon}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                {importResults.successful.length === 0 &&
                  importResults.failed.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        style={{ textAlign: "center", padding: 32 }}
                      >
                        <Typography variant="body2" color="textSecondary">
                          No hay resultados para mostrar
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>

          {importResults.conflictsByDevice &&
            Object.keys(importResults.conflictsByDevice).length > 0 && (
              <Box mt={3}>
                <Typography variant="h6" gutterBottom>
                  Identificaciones Duplicadas por Dispositivo
                </Typography>
                <Grid container spacing={2}>
                  {Object.entries(importResults.conflictsByDevice).map(
                    ([deviceId, conflicts]) => (
                      <Grid item xs={12} sm={6} md={4} key={deviceId}>
                        <Paper
                          style={{
                            padding: 12,
                            backgroundColor: "#fff8e1",
                            border: "1px solid #ffcc02",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            style={{ fontWeight: "bold" }}
                          >
                            📱 {getDeviceNameById(deviceId)}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {conflicts.length} identificaciones ya existían:
                          </Typography>
                          <Typography
                            variant="caption"
                            style={{
                              wordBreak: "break-all",
                              backgroundColor: "#fff",
                              padding: "4px 8px",
                              borderRadius: 4,
                              display: "block",
                              marginTop: 4,
                            }}
                          >
                            {conflicts.join(", ")}
                          </Typography>
                        </Paper>
                      </Grid>
                    )
                  )}
                </Grid>
              </Box>
            )}

          <Box textAlign="center" mt={3}>
            <Button variant="contained" color="primary" onClick={onClose}>
              Cerrar
            </Button>
          </Box>
        </Box>
      )}
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} disabled={importLoading}>
        {importStep === 4 ? "Cerrar" : "Cancelar"}
      </Button>
      {importStep === 1 && importFile && !importLoading && (
        <Button
          onClick={handleProcessImportFile}
          color="primary"
          variant="contained"
        >
          Procesar Archivo
        </Button>
      )}
      {importStep === 2 && selectedBiometricDevices.length > 0 && (
        <Button
          onClick={handleContinueWithDevices}
          color="primary"
          variant="contained"
        >
          Continuar con Dispositivos
        </Button>
      )}
      {importStep === 3 && importData?.validRows > 0 && (
        <Button
          onClick={handleMassImport}
          color="primary"
          variant="contained"
          disabled={importLoading}
        >
          {importLoading ? "Importando..." : "Importar Rostros"}
        </Button>
      )}
    </DialogActions>
  </Dialog>
)

export default ImportMasivoDialog
